interface Divider {
    text: string;
}

export function Divider({ text }: Divider) {
    return (
        <div className="flex items-center gap-2 w-full max-w-2xl">
            <hr className="text-gray-200 w-full" />
            <h3 className="text-nowrap text-gray-900 font-medium">{text}</h3>
            <hr className="text-gray-200 w-full" />
        </div>
    );
}